import { fmt } from '@/lib/utils'
import { useKioskStore } from '@/stores/kiosk-store'

export default function FloatingCart() {
  const cart = useKioskStore((s) => s.cart)
  const step = useKioskStore((s) => s.step)
  const setStep = useKioskStore((s) => s.setStep)
  const resetToAttractor = useKioskStore((s) => s.resetToAttractor)
  const locale = useKioskStore((s) => s.locale)
  const sv = locale === 'sv'

  const totalItems = cart.reduce((s, i) => s + i.count, 0)
  const totalAmount = cart.reduce((s, i) => s + i.price * i.count, 0)

  // Empty cart: show a "Starta Om" button while browsing, so guests who don't
  // spot the Tillbaka arrow always have a clear way back to the start screen.
  if (totalItems === 0) {
    if (step !== 'browsing') return null
    return (
      <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-40">
        <button
          onClick={resetToAttractor}
          className="kiosk-btn relative flex items-center gap-4 px-10 py-5 bg-white text-black rounded-full shadow-2xl shadow-black/60 active:scale-95 transition-all min-w-[320px] justify-center"
        >
          <svg viewBox="0 0 24 24" className="w-10 h-10 fill-black shrink-0">
            <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" />
          </svg>
          <span className="font-extrabold text-2xl">{sv ? 'Ny Order' : 'New Order'}</span>
        </button>
      </div>
    )
  }

  // Bold white pill with accent badge — deliberately large so customers can't miss it
  return (
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-40">
      <button
        onClick={() => setStep('cart')}
        className="kiosk-btn relative flex items-center gap-4 px-10 py-5 bg-white text-black rounded-full shadow-2xl shadow-black/60 active:scale-95 transition-all min-w-[320px] justify-center"
      >
        {/* Cart icon with count badge */}
        <div className="relative">
          <svg viewBox="0 0 24 24" className="w-10 h-10 fill-black shrink-0">
            <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
          </svg>
          <span className="absolute -top-2 -right-2 bg-kiosk-accent text-white w-7 h-7 rounded-full text-sm font-black flex items-center justify-center ring-2 ring-white shadow">{totalItems}</span>
        </div>

        <div className="flex flex-col items-start leading-tight">
          <span className="font-extrabold text-3xl">{fmt(totalAmount)}</span>
          <span className="text-lg font-semibold text-kiosk-accent">{sv ? 'Till Betalning' : 'Checkout'}</span>
        </div>
      </button>
    </div>
  )
}
